import { render, staticRenderFns } from "./DescredenciadoCard.vue?vue&type=template&id=2538d997&scoped=true"
import script from "./DescredenciadoCard.vue?vue&type=script&lang=js"
export * from "./DescredenciadoCard.vue?vue&type=script&lang=js"
import style0 from "./DescredenciadoCard.vue?vue&type=style&index=0&id=2538d997&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538d997",
  null
  
)

export default component.exports